import { InjectionToken, Type } from '@angular/core';

import { ColumnSettings } from 'sc-common/shared/table/models/column-settings';

export const DEFAULT_COLUMN_SETTINGS = new InjectionToken<IModuleColumnSettingsProvider>('DefaultColumnSettings');

export interface IModuleColumnSettingsProvider {
    getDefault(columnType: Type<number | string | Date>): ColumnSettings;
}
